/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// component
import Ratings from 'pages/dashboard/ratings/ratings';



/* ========== ~~~~~~~~~~ RATINGS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ ratingsState, sessionStatus }) => ({
    fetchingRatingsData: ratingsState.ratingsStatus.fetchingRatingsData,
    dataFetchFailed: ratingsState.ratingsStatus.dataFetchFailed,
    isDataReceived: ratingsState.ratingsStatus.isDataReceived,
    requestStatus: ratingsState.ratingsStatus.requestStatus,
    permissions: sessionStatus.permissions,
    mockupGenerator: sessionStatus.mockupGenerator,
    siteUUID: sessionStatus.siteUUID,
    hasRatingsUnit: ratingsState.ratingsStatus.hasRatingsUnit
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
)(Ratings));
